/*
    This service add the event listener to logout the application
*/

export const logoutService = authModule => {
  window.addEventListener('popstate', () => {
    if (window.location.pathname === '/logout') {
      authModule.Logout();
    }
  });
};
